import { restApi } from '../../api';
import { GetBrandContextOutput } from './context.types';

const PATH = 'context';

export const getBrandContext = () => restApi.get<GetBrandContextOutput>(`${PATH}/brands/v1`);
